import {MediaApi} from '../../network/MediaApi';
import {Result} from '../../network/models/Response';
import {Media} from '../../models/Media';

export class MediaProvider {
    private loaded = false;
    private cache: Media[] = [];

    constructor(private mediaApi: MediaApi) {}

    public async get(): Promise<Media[]> {
        if (this.loaded) {
            return this.cache;
        }

        const response = await this.mediaApi.get();
        if (response.result === Result.Success) {
            this.cache = response.data!;
            this.loaded = true;
            return this.cache;
        }

        throw new Error('Failed to load media items');
    }
}
